(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/engine/assets/javascripts/make-engine.js') >= 0) return;  svs.modules.push('/components/tipsen/engine/assets/javascripts/make-engine.js'); "use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const {
  constants
} = svs.components.tipsen.engine;
const initialState = {
  productId: 0,
  selectedDraw: -1,
  betAmounts: [1],
  selectedBetAmount: 0,
  coupon: [],
  systems: [constants.systems.SYSTEM_MSYS],
  selectedSystem: 0,
  maxDepositPerRound: 20000
};
const requiredProps = ['maxSystemSize'];


const makeEngineState = engineConfig => {
  let state;
  if (typeof engineConfig === 'function') {
    state = engineConfig();
  } else {
    state = engineConfig;
  }
  const missingProp = requiredProps.filter(prop => !state[prop]).pop();
  if (missingProp) {
    throw new Error("missing required property: ".concat(missingProp));
  }
  return _objectSpread(_objectSpread({}, initialState), state);
};
setGlobal('svs.components.tipsen.engine.makeEngineState', makeEngineState);
 })(window);